import React, { useState, useEffect } from 'react';
import { unixTimestampToDate } from '../../../../../ressources/functionJS/unixTimestampToDate';
import styles from './FormulaireSelectionDateHeureUnix.module.scss';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import { dateValider } from '../../../../../ressources/functionJS/dateValide';
import { validerHeure } from '../../../../../ressources/functionJS/heureValide';

const FormulaireSelectionDateHeureUnix = ({
  value,
  disabled = false,
  gereUnixDate,
}) => {
  // Split state into multiple useState hooks
  const [dateValide, setDateValide] = useState(true);
  const [heureValide, setHeureValide] = useState(true);
  const [active, setActive] = useState(
    (value !== undefined && value !== null && !isNaN(value)) || disabled
  );
  const [defaultDate, setDefaultDate] = useState(null);
  const [defaultTime, setDefaultTime] = useState(null);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState('00:00');

  useEffect(() => {
    const isValidValue = value !== undefined && value !== null && !isNaN(value);

    // Batch all state updates
    if (value === null) {
      // Reset all states at once to avoid multiple re-renders
      const resetState = {
        dateValide: true,
        heureValide: true,
        active: false,
        defaultDate: null,
        defaultTime: null,
        date: null,
        time: null,
      };

      setDateValide(resetState.dateValide);
      setHeureValide(resetState.heureValide);
      setActive(resetState.active);
      setDefaultDate(resetState.defaultDate);
      setDefaultTime(resetState.defaultTime);
      setDate(resetState.date);
      setTime(resetState.time);
      return;
    }

    if (isValidValue) {
      // Calculate all values before any state updates
      const dateTimeStr = unixTimestampToDate(value).split(', ');
      const [dateStr, timeStr] = dateTimeStr;
      const dateParts = dateStr.split('/');
      const formattedDate = dateParts.reverse().join('-');

      // Batch state updates
      setDateValide(true);
      setHeureValide(true);
      setActive(true || disabled);
      setDefaultDate(dateParts);
      setDefaultTime(timeStr.split(':'));
      setDate(formattedDate);
      setTime(timeStr);
    }
  }, [value, disabled]); // Only depend on external props

  const envoiDate = (dateValue, timeValue) => {
    if (dateValue !== null) {
      gereUnixDate(new Date(dateValue + 'T' + timeValue).getTime() / 1000);
    } else {
      gereUnixDate(null);
    }
  };

  const handleDateChange = (event) => {
    if (dateValider(event.target.value)) {
      setDate(event.target.value);
      setDateValide(true);
      envoiDate(event.target.value, time);
    } else {
      setDate(event.target.value);
      setDateValide(false);
    }
  };

  const handleTimeChange = (event) => {
    if (validerHeure(event.target.value)) {
      setTime(event.target.value);
      setHeureValide(true);
      envoiDate(date, event.target.value);
    } else {
      setTime(event.target.value);
      setHeureValide(false);
    }
  };

  const handleDeactivate = () => {
    setActive(false);
    setDate(null);
    setTime(null);
    envoiDate(null, null);
  };

  const handleActivate = () => {
    const isValidValue = value !== undefined && value !== null && !isNaN(value);
    const dateTimeStr = isValidValue
      ? unixTimestampToDate(value).split(', ')
      : ['', '00:00'];

    const dateValue = isValidValue
      ? dateTimeStr[0].split('/').reverse().join('-')
      : null;
    const timeValue = dateTimeStr[1];

    setActive(true);
    setDate(dateValue);
    setTime(timeValue);
    envoiDate(dateValue, timeValue);
  };

  const classNameDate = [styles.style];
  if (!dateValide) classNameDate.push(styles.wrong);

  const classNameHeure = [styles.style];
  if (!heureValide) classNameHeure.push(styles.wrong);

  if (!active) {
    return (
      <div className={styles.BoutonDiv} onClick={handleActivate}>
        {checkMot('active_la_plage_de_temps')}
      </div>
    );
  }

  return (
    <div>
      <input
        className={classNameDate.join(' ')}
        type="date"
        defaultValue={
          defaultDate
            ? `${defaultDate[2]}-${defaultDate[1]}-${defaultDate[0]}`
            : null
        }
        value={date}
        onChange={handleDateChange}
        disabled={disabled}
      />

      <input
        className={classNameHeure.join(' ')}
        type="time"
        pattern="([01]?[0-9]|2[0-3]):[0-5][0-9]"
        defaultValue={
          defaultTime ? `${defaultTime[0]}:${defaultTime[1]}` : '00:00'
        }
        onChange={handleTimeChange}
        disabled={disabled}
      />

      {!disabled && (
        <div className={styles.BoutonDiv} onClick={handleDeactivate}>
          {checkMot('desactive_la_plage_de_temps')}
        </div>
      )}
    </div>
  );
};

export default FormulaireSelectionDateHeureUnix;
